<!--
 * @Author: your name
 * @Date: 2022-03-04 16:41:49
 * @LastEditTime: 2022-03-07 14:35:28
 * @LastEditors: 么东欣
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /bijixia-wx-h5/src/components/select/area.vue
-->
<template>
  <ios-select
    :sourceData="sourceData"
    :level="3"
    :required="required"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    :readonly="readonly"
    :disabled="disabled"
    :outline="outline"
    :size="size"
    :placeholderColor="placeholderColor"
    :relation="[1, 1]"
    v-model="value"
    @change="change"
  >
    <template v-slot:suffix>
      <i class="iconfont icon-gengduoyonghu"></i>
    </template>
  </ios-select>
</template>

<script>
import { iosProvinces, iosCities, iosCounties } from './src/js/area'
import iosSelect from './index.vue'

export default {
  components: {
    iosSelect,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [Number, Array, String],
      default: '',
    },
    label: {
      type: String,
      default: '标签',
    }, //label
    placeholder: {
      type: String,
      default: '',
    }, //原生属性
    clearable: {
      type: Boolean,
      default: false,
    }, //Todo...
    disabled: {
      type: Boolean,
      default: false,
    }, //原生属性
    readonly: {
      type: String,
      default: '',
    }, //原生属性，是否只读
    outline: {
      type: Boolean,
      default: false,
    }, //全边框输入框
    size: {
      type: String,
      default: 'middle', //large big middle small xs
    },
    placeholderColor: {
      type: String,
      default: '#979797',
    },
  },
  emits: ['change'],
  data() {
    return {
      sourceData: [iosProvinces, iosCities, iosCounties],
      value: [],
    }
  },
  watch: {
    modelValue(v) {
      this.value = v
    },
  },
  methods: {
    change(v) {
      this.value = v
      this.$emit('change', v)
    },
  },
}
</script>

<style lang="less" scoped>
.iconfont {
  color: #ccc;
}
</style>
